// CalibrationLogBookRouteUtils.js
// Helpers to parse and build canonical /home/calibration_logs routes.

const BASE = "/home/calibration_logs";

export function parseCalibrationLogBookRoute(pathname, search) {
  if (!pathname || !pathname.startsWith(BASE)) return {};
  const parts = pathname.split("/").filter(Boolean); // ["home", "calibration_logs", ...]
  const seg = parts[2] || null; // e.g., "new" or "book_form"

  let mode = "table"; // table | create | book
  if (seg === "new") mode = "create";
  if (seg === "book_form") mode = "book";

  const params = new URLSearchParams(search || "");
  const bookId = params.get("book_id") || null;

  return { mode, bookId };
}

export function buildCalibrationLogBookPath({ mode, bookId }) {
  if (mode === "create") return `${BASE}/new`;
  if (mode === "book") {
    const query = new URLSearchParams();
    if (bookId) query.set("book_id", bookId);
    const qs = query.toString();
    return qs ? `${BASE}/book_form?${qs}` : `${BASE}/book_form`;
  }
  return BASE; // table
}

export function canonicalizeCalibrationLogBookLocation(locationLike) {
  const pathname = locationLike?.pathname || "";
  const search = locationLike?.search || "";
  if (!pathname.startsWith(BASE)) return null;
  const parsed = parseCalibrationLogBookRoute(pathname, search);
  const canonical = buildCalibrationLogBookPath(parsed);
  const current = `${pathname}${search || ""}`;
  return canonical !== current ? canonical : null;
}
